<div class='container{{columnClass}}'>
	<ib-menu-card *ngFor='let item of items.list'
		[item]='item'
		(click)='onClick(item)'
		(badgeClick)='onBadgeClick($event)'>
	</ib-menu-card>
</div>
